/* unplugin-vue-components disabled */import { render } from "./AskForVideoDetails.vue?vue&type=template&id=40148070&scoped=true"
import script from "./AskForVideoDetails.vue?vue&type=script&lang=js"
export * from "./AskForVideoDetails.vue?vue&type=script&lang=js"

import "./AskForVideoDetails.vue?vue&type=style&index=0&id=40148070&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40148070"]])

export default __exports__